/**
 * Resolve a prototype-relative asset path (e.g. `images/tools/notion.png`)
 * to an absolute public URL served by Vite/Vercel (`/images/tools/notion.png`).
 */
export function asset(path: string): string {
  if (!path) return path;
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path;
  return path.startsWith('/') ? path : `/${path}`;
}
